import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';


import { environment } from '../../../../environments/environment';

import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [AuthService]
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  private API_URL = environment.API_URL;
  private images = ["pic1.jpg","pic2.jpg","pic3.jpg","pic4.jpg"]
  private selectedImage:string;
  constructor(private toasterService: ToasterService, fb: FormBuilder, private authService: AuthService, private router: Router) {
    this.selectedImage = this.images[Math.floor(Math.random() * this.images.length)];
    this.loginForm = fb.group({
      'email': [null, Validators.required],
      'password': [null, Validators.required]
    });
    this.toasterService = toasterService;

  }

  submitForm($ev, form: FormGroup) {
    $ev.preventDefault();
    let value = form.value;
    for (let c in form.controls) {
      form.controls[c].markAsTouched();
    }
    if (form.valid) {
      this.authService.login(value.email, value.password).subscribe(
        data => {
          if (data === false) {
            // login failed
            this.toasterService.pop('error', 'Something went wrong!');
          }
          // old mysql login
          if (data.user.roles.hasOwnProperty('account') || data.user.roles.hasOwnProperty('admin')) {
            this.router.navigate(['dashboard']);
          }
          const roles = data.user.roles.map(role => role.name);
          if (roles.includes('dealer_portal')) {
            this.router.navigate(['dealers-portal']);
          } else if (roles.includes('business')) {
            this.router.navigate(['business']);
          } else if (roles.includes('admin')) {
              this.router.navigate(['dashboard']);
          } else {
              // login failed
              this.toasterService.pop('error', 'Something went wrong!');
          }
        },
        error => {
          this.toasterService.pop('error', 'Username or password is incorrect');
        }
      );
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/routes/user/login/login.component.ts